import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreLayoutContentViewModule } from '@auto-editor/core/layout/content/view';
import { CoreLayoutFeatureHeaderModule } from '@auto-editor/core/layout/feature-header';
import { LayoutComponent } from './layout/layout.component';

@NgModule({
  imports: [CommonModule, CoreLayoutFeatureHeaderModule, CoreLayoutContentViewModule],
  declarations: [LayoutComponent],
  exports: [LayoutComponent]
})
export class CoreLayoutMainModule {}
